import * as React from "react";
import styles from "./StepperComponent.module.scss";
import classnames from "classnames";

function Step({ text, current, done, onClick }) {
    return (
        <div onClick={onClick} className={classnames(styles["step"], current && styles["step-current"], done && styles["step-done"], onClick && styles["step-clickable"])}>
            <div className={styles["text"]}>{text}</div>
            <div className={classnames(styles["line"])} />
        </div>
    );
}

export function StepperComponent(props) {
    const { currentStep, maxSteps, onClick, getLocaleText } = props;
    if (!currentStep) {
        return null;
    }
    return (
        <div className={styles["wrapper"]}>
            <Step text={getLocaleText("items")} onClick={currentStep !== 1 ? () => onClick(1) : undefined} current={currentStep === 1} done={currentStep > 1} />
            {maxSteps === 3 && <Step text={getLocaleText("shipping")} onClick={currentStep !== 2 ? () => onClick(2) : undefined} current={currentStep === 2} done={currentStep > 2} />}
            <Step
                text={getLocaleText("confirm")}
                color={"gray"}
                onClick={currentStep === maxSteps - 1 ? () => onClick(maxSteps) : undefined}
                current={currentStep === maxSteps}
                done={currentStep > maxSteps}
            />
            <div
                style={{
                    width: `calc(${Math.min(currentStep / maxSteps, 1) * 100}% - 2px`,
                }}
                className={styles["colored-line"]}
            />
        </div>
    );
}
